import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Navigator from "../../../Common/layouts/Navigator/Navigator";
import QuantityInput from "../../components/QuantityInput/QuantityInput";
import ProductDetails from "../../components/ProductDetails/ProductDetails.component";
import {
  selectIsTrackClosed,
  selectMc12Steps,
  setMc12CurrentStep,
  selectNbSegments,
  setCalculatedCommunication,
  selectCalculatedCommunication,
  selectAccessories,
  selectShouldRecalculateCommunication,
  setShouldRecalculateCommunication,
  selectCalculatedCommunicationSfoCablesView,
  selectCalculatedCommunicationSercosCablesView
} from "../../store/slices/mc12";
import { getProductImgUrl } from "../../../Common/utils/api/api";
import t from "../../../Common/utils/translation/translator";
import { genCommunication } from "../../../Mc12/utils/func.utils";
import { updateConfiguration } from "../../../Common/store/slices/common";

const Communication = () => {
  const dispatch = useDispatch();
  const mc12Steps = useSelector(selectMc12Steps);
  const isTrackClosed = useSelector(selectIsTrackClosed);
  const nbSegments = useSelector(selectNbSegments);
  const accessories = useSelector(selectAccessories);
  const calculatedCommunication = useSelector(selectCalculatedCommunication);
  const shouldRecalculateComm = useSelector(selectShouldRecalculateCommunication);
  const sfoCablesView = useSelector(selectCalculatedCommunicationSfoCablesView);
  const sercosCablesView = useSelector(selectCalculatedCommunicationSercosCablesView);

  useEffect(() => {
    let tmpCommunication = JSON.parse(JSON.stringify(calculatedCommunication));

    if (shouldRecalculateComm) {
      // init Communication
      tmpCommunication = genCommunication(accessories, nbSegments);
      const tmpCommunicationCalculated = calculateCommunication(
        tmpCommunication,
        getMinSafetyGroupsNumber(),
        nbSegments,
        isTrackClosed
      );
      tmpCommunicationCalculated.sfoCablesView = calculateTheViewFromQuantities(tmpCommunicationCalculated.sfoCables);
      tmpCommunicationCalculated.sercosCablesView = calculateTheViewFromQuantities(
        tmpCommunicationCalculated.sercosCables
      );
      dispatch(setCalculatedCommunication(tmpCommunicationCalculated));
      dispatch(setShouldRecalculateCommunication(false));
    } else {
      if (!tmpCommunication.sfoCablesView && !tmpCommunication.sercosCablesView) {
        tmpCommunication.sfoCablesView = calculateTheViewFromQuantities(tmpCommunication.sfoCables);
        tmpCommunication.sercosCablesView = calculateTheViewFromQuantities(tmpCommunication.sercosCables);
        dispatch(setCalculatedCommunication(tmpCommunication));
      }
    }
  }, []);

  function calculateCommunication(communication, nbSafetyGroup, segments, trackIsClosed) {
    // console.log("calculateCommunication", communication, nbSafetyGroup, segments, trackIsClosed);
    const tmpCommunication = JSON.parse(JSON.stringify(communication));
    tmpCommunication.safetyGroup = nbSafetyGroup;
    if (trackIsClosed) {
      tmpCommunication.sfoInterconnects.quantity = nbSafetyGroup;
      tmpCommunication.sercosInterconnects.quantity = 1;
      // const piece_10_quantity = Math.floor((segments - tmpCommunication.sfoInterconnects.quantity - 1) / 10);
      // const piece_1_quantity = Math.ceil((segments - tmpCommunication.sfoInterconnects.quantity - 1) % 10);
      const piece_1_quantity = segments - tmpCommunication.sfoInterconnects.quantity - 1;
      const communicationInterconnectsOnePieceIndex = tmpCommunication.communicationInterconnects.findIndex(
        (e) => e.quantityPerSet === "1_PIECE"
      );
      // const communicationInterconnectsOneTenPiecesIndex = tmpCommunication.communicationInterconnects.findIndex(
      //   (e) => e.quantityPerSet === "10_PIECES"
      // );
      tmpCommunication.communicationInterconnects[communicationInterconnectsOnePieceIndex].quantity = piece_1_quantity;
      // tmpCommunication.communicationInterconnects[communicationInterconnectsOneTenPiecesIndex].quantity =
      //   piece_10_quantity;
    } else {
      tmpCommunication.openSercosSfo.quantity = 1;
      tmpCommunication.sfoInterconnects.quantity = nbSafetyGroup - 1;
      tmpCommunication.openSercos.quantity = 1;

      // const piece_10_quantity = Math.floor(
      //   (segments -
      //     tmpCommunication.openSercosSfo.quantity -
      //     tmpCommunication.sfoInterconnects.quantity -
      //     tmpCommunication.openSercos.quantity +
      //     1) /
      //     10
      // );
      // const piece_1_quantity = Math.ceil(
      //   ((segments -
      //     tmpCommunication.openSercosSfo.quantity -
      //     tmpCommunication.sfoInterconnects.quantity -
      //     tmpCommunication.openSercos.quantity +
      //     1) %
      //     10) -
      //     piece_10_quantity
      // );
      const piece_1_quantity =
        segments -
        tmpCommunication.openSercosSfo.quantity -
        tmpCommunication.sfoInterconnects.quantity -
        tmpCommunication.openSercos.quantity +
        1;
      const communicationInterconnectsOnePieceIndex = tmpCommunication.communicationInterconnects.findIndex(
        (e) => e.quantityPerSet === "1_PIECE"
      );
      // const communicationInterconnectsOneTenPiecesIndex = tmpCommunication.communicationInterconnects.findIndex(
      //   (e) => e.quantityPerSet === "10_PIECES"
      // );
      tmpCommunication.communicationInterconnects[communicationInterconnectsOnePieceIndex].quantity = piece_1_quantity;
      // tmpCommunication.communicationInterconnects[communicationInterconnectsOneTenPiecesIndex].quantity =
      //   piece_10_quantity;
    }
    return tmpCommunication;
  }

  function setSafetyGroupsNumber(number) {
    // console.log("setSafetyGroupsNumber", number);
    const tmpCommunicationCalculated = calculateCommunication(
      calculatedCommunication,
      number,
      nbSegments,
      isTrackClosed
    );
    tmpCommunicationCalculated.sfoCablesView = setSfoCablesInTheView(tmpCommunicationCalculated.sfoCablesView, number);

    // Setting the right quantities
    tmpCommunicationCalculated.sfoCables = calculateCablesQuantitiesFromTheView(
      tmpCommunicationCalculated.sfoCables,
      tmpCommunicationCalculated.sfoCablesView
    );
    dispatch(setCalculatedCommunication(tmpCommunicationCalculated));
  }

  function getMaxSafetyGroupsNumber() {
    return isTrackClosed ? nbSegments - 1 : nbSegments;
  }

  function getMinSafetyGroupsNumber() {
    // console.log("getMinSafetyGroupsNumber");
    return Math.ceil(nbSegments / 68);
  }

  function setSfoCable(id, newValue) {
    // console.log("setSfoCable", id, newValue);
    const tmpCommunicationCalculated = JSON.parse(JSON.stringify(calculatedCommunication));
    // Setting the right view
    const cableViewIndex = tmpCommunicationCalculated.sfoCablesView.findIndex((cv) => cv.id === id);
    if (cableViewIndex > -1) {
      tmpCommunicationCalculated.sfoCablesView[cableViewIndex].val = newValue;
    } else {
      tmpCommunicationCalculated.sfoCablesView.push({
        id: tmpCommunicationCalculated.sfoCablesView[tmpCommunicationCalculated.sfoCablesView.length - 1].id + 1,
        val: newValue
      });
    }
    // Setting the right quantities
    tmpCommunicationCalculated.sfoCables = calculateCablesQuantitiesFromTheView(
      tmpCommunicationCalculated.sfoCables,
      tmpCommunicationCalculated.sfoCablesView
    );
    dispatch(setCalculatedCommunication(tmpCommunicationCalculated));
  }

  function setSercosCable(id, newValue) {
    // console.log("setSercosCable", id, newValue);
    const tmpCommunicationCalculated = JSON.parse(JSON.stringify(calculatedCommunication));
    // Setting the right view
    const cableViewIndex = tmpCommunicationCalculated.sercosCablesView.findIndex((cv) => cv.id === id);
    if (cableViewIndex > -1) {
      tmpCommunicationCalculated.sercosCablesView[cableViewIndex].val = newValue;
    } else {
      tmpCommunicationCalculated.sercosCablesView.push({
        id: tmpCommunicationCalculated.sercosCablesView[tmpCommunicationCalculated.sfoCablesView.length - 1].id + 1,
        val: newValue
      });
    }
    // Setting the right quantities
    tmpCommunicationCalculated.sercosCables = calculateCablesQuantitiesFromTheView(
      tmpCommunicationCalculated.sercosCables,
      tmpCommunicationCalculated.sercosCablesView
    );
    dispatch(setCalculatedCommunication(tmpCommunicationCalculated));
  }

  function calculateCablesQuantitiesFromTheView(cables, cablesView) {
    // console.log("calculateCablesQuantitiesFromTheView");
    const tmpCables = JSON.parse(JSON.stringify(cables));
    // init all quantities
    tmpCables.forEach((cable) => (cable.quantity = 0));
    // calculate quantities again from the view
    cablesView.forEach((cableView) => {
      const cableIndex = tmpCables.findIndex((cable) => extractCableLength(cable) === cableView.val);
      if (cableIndex > -1) {
        tmpCables[cableIndex].quantity += 1;
      }
    });
    return tmpCables;
  }

  function setSfoCablesInTheView(sfoCablesView, number) {
    // console.log("setSfoCablesInTheView", number);
    // INCREMENT
    if (sfoCablesView.length <= number) {
      Array.from({ length: number - sfoCablesView.length }).forEach(() => {
        let lastId = sfoCablesView.length > 0 ? sfoCablesView[sfoCablesView.length - 1].id : 0;
        sfoCablesView.push({
          id: lastId + 1,
          val: "5 m"
        });
      });
      // DECREMENT
    } else {
      sfoCablesView.splice(-(sfoCablesView.length - number));
    }
    return sfoCablesView;
  }

  function calculateTheViewFromQuantities(cables) {
    // console.log("calculateTheViewFromQuantities");
    const tmpCablesView = [];
    let index = 1;
    // calculate the view
    cables.forEach((cable) => {
      if (cable.quantity > 0) {
        for (let i = 0; i < cable.quantity; i++) {
          tmpCablesView.push({ id: index++, val: extractCableLength(cable) });
        }
      }
    });
    return tmpCablesView;
  }

  function extractCableLength(cable) {
    // console.log("extractCableLength");
    const regex = /((?<=[-\s])\d+) ?m(?=\b)/; // match 5m and 5 m but in a group we match only 5
    return regex.exec(cable.mediumDescription)[1] + " m";
  }

  return (
    <div className="py-3">
      <div className="w-80">
        <QuantityInput
          data-testid="quantity-input-communication"
          label={t("mc12.ui.step.communication.title.quantity_sfo")}
          min={getMinSafetyGroupsNumber()}
          max={getMaxSafetyGroupsNumber()}
          isRequired
          onValueChange={(value) => {
            setSafetyGroupsNumber(value);
          }}
          initialValue={
            calculatedCommunication.safetyGroup > 1 && !shouldRecalculateComm
              ? calculatedCommunication.safetyGroup
              : getMinSafetyGroupsNumber()
          }
        />
      </div>
      <span className="text-sm text-gray-400 mt-3">{t("mc12.ui.step.communication.title.default")}</span>
      <div className="h-px bg-gray-200 my-5"> </div>
      <div className="flex flex-col gap-y-7 max-w-fit">
        <div className="flex">
          <div className="self-start">
            {isTrackClosed ? (
              <ProductDetails
                num={calculatedCommunication.sfoInterconnects?.quantity}
                image={getProductImgUrl(calculatedCommunication.sfoInterconnects?.commercialReference)}
                title={t("mc12.ui.step.communication.title.sfo_interconnect")}
                horizontal
              />
            ) : (
              <>
                <ProductDetails
                  num={calculatedCommunication.openSercosSfo?.quantity}
                  image={getProductImgUrl(calculatedCommunication.openSercosSfo?.commercialReference)}
                  title={t("mc12.ui.step.communication.title.connector_open_track_sercos_sfo")}
                  horizontal
                />
                {calculatedCommunication.safetyGroup > 1 && (
                  <ProductDetails
                    num={calculatedCommunication.sfoInterconnects.quantity}
                    image={getProductImgUrl(calculatedCommunication.sfoInterconnects?.commercialReference)}
                    title={t("mc12.ui.step.communication.title.sfo_interconnect")}
                    horizontal
                  />
                )}
              </>
            )}
          </div>
          <div className="flex gap-x-2">
            <img
              src={getProductImgUrl(
                calculatedCommunication.sfoCables ? calculatedCommunication.sfoCables[0]?.commercialReference : null
              )}
              alt=""
              className="w-32 self-start mt-6"
            />
            <div className="space-y-5 mt-10">
              {sfoCablesView &&
                sfoCablesView.map((element) => (
                  <div key={element.id} className="flex gap-x-3 items-center">
                    <span className="text-lg">1</span>
                    <select
                      className="w-28 rounded-sm border-gray-400"
                      onChange={(e) => {
                        setSfoCable(element.id, e.target.value);
                      }}
                      defaultValue={element.val}
                    >
                      <option>2 m</option>
                      <option>5 m</option>
                      <option>10 m</option>
                      <option>15 m</option>
                      <option>20 m</option>
                    </select>
                    <span className="text-sm">{t("mc12.ui.step.communication.title.sfo_cable")}</span>
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div className="h-px bg-gray-200 my-5"> </div>
        <div className="flex">
          <div className="self-start">
            {isTrackClosed ? (
              <ProductDetails
                num={calculatedCommunication.sercosInterconnects?.quantity}
                image={getProductImgUrl(calculatedCommunication.sercosInterconnects?.commercialReference)}
                title={t("mc12.ui.step.communication.title.comm_interconnectes_sercos")}
                horizontal
              />
            ) : (
              <ProductDetails
                num={calculatedCommunication.openSercosSfo?.quantity}
                image={getProductImgUrl(calculatedCommunication.openSercosSfo?.commercialReference)}
                title={t("mc12.ui.step.communication.title.connector_open_track_sercos")}
                horizontal
              />
            )}
          </div>
          <div className="flex gap-x-2">
            <img
              src={getProductImgUrl(
                calculatedCommunication.sercosCables
                  ? calculatedCommunication.sercosCables[0]?.commercialReference
                  : null
              )}
              alt=""
              className="w-32 self-start mt-6"
            />
            <div className="space-y-5 mt-8">
              <div className="space-y-3">
                {sercosCablesView &&
                  sercosCablesView.map((element) => (
                    <div key={element.id} className="flex gap-x-3 items-center">
                      <span className="text-lg">1</span>
                      <select
                        className="w-28 rounded-sm border-gray-400"
                        onChange={(e) => {
                          setSercosCable(element.id, e.target.value);
                        }}
                        defaultValue={element.val}
                      >
                        <option>3 m</option>
                        <option>5 m</option>
                        <option>10 m</option>
                      </select>
                      <span className="text-sm">{t("mc12.ui.step.communication.title.sercos_cable")}</span>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
        <div className="h-px bg-gray-200 my-5"> </div>
        <ProductDetails
          num={calculatedCommunication?.communicationInterconnects?.reduce((a, b) => {
            if (b.quantityPerSet === "10_PIECES") {
              return a + b.quantity * 10;
            } else {
              return a + b.quantity;
            }
          }, 0)}
          image={getProductImgUrl(
            calculatedCommunication.communicationInterconnects
              ? calculatedCommunication.communicationInterconnects[0]?.commercialReference
              : null
          )}
          title={t("mc12.ui.step.communication.title.comm_interconnectes")}
          horizontal
        />
      </div>
      <Navigator
        continueAction={() => {
          dispatch(setMc12CurrentStep(mc12Steps.ACCESSORIES));
          dispatch(updateConfiguration());
        }}
      />
    </div>
  );
};

export default Communication;
